import React from "react";
import { useNavigate } from "react-router-dom";
import classes from "./MobileMenu.module.css";

const MobileMenu = (props) => {
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
        props.hideMobileMenuHandler();
    };

    return (
        <div
            className={`${classes.mobile_menu_overlay} ${props.mobileMenu && classes.show
                }`}
            onClick={() => props.hideMobileMenuHandler()}
        >
            <div
                className={`${classes.mobile_menu_container} ${props.mobileMenu && classes.show
                    }`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={classes.mobile_menu_sub_container}>
                    <div className={classes.logo_center}>
                        <img
                            src="/assets/images/rainboo-logo-bg.png"
                            alt="Rainboo"
                            className={classes.logo}
                        />
                    </div>
                    <div
                        className={`${classes.tab} ${props.active == 1 && classes.active}`}
                        onClick={() => handleNavigate("/home")}
                    >
                        <i className={`pi pi-chart-line ${classes.sidebar_bar_icon}`}></i>
                        <span>
                            Revenue Insights
                        </span>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default MobileMenu;